import { render, staticRenderFns } from "./healthReport.vue?vue&type=template&id=4f792894&scoped=true&"
import script from "./healthReport.vue?vue&type=script&lang=js&"
export * from "./healthReport.vue?vue&type=script&lang=js&"
import style0 from "./healthReport.vue?vue&type=style&index=0&id=4f792894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f792894",
  null
  
)

export default component.exports